var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{class:{ drawer: true }},[_c('div',{staticClass:"drawer-mask"}),_c('div',{staticClass:"drawer-wrap",on:{"click":_vm.doClose}},[_c('div',{staticClass:"bottom"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }